export enum AuthoritySale {
  MOVIMENTATION_SALE_LINK_SELLER_TO_LOGGED_USER = '2.7.23',
  MOVIMENTATION_SALE_ADD_DISCOUNT_PERCENTAGE_GREATER_THAN_DEFINED_BY_THE_COMPANY = '2.7.22',
  MOVIMENTATION_SALE_EDIT_AUTHORIZATION_DATE = '2.7.21',
  MOVIMENTATION_SALE_EDIT_DATE = '2.7.20',
  MOVIMENTATION_SALE_ITEM_EDIT_DISCOUNT_VALUE = '2.7.19',
  MOVIMENTATION_SALE_ITEM_EDITE_SALE_VALUE = '2.7.18',
  MOVIMENTATION_SALE_GENERATE_INVOICE = '2.7.17',
  MOVIMENTATION_SALE_ITEM_VIEW = '2.7.24',
  MOVIMENTATION_SALE_ALLOW_TO_ENTER_ITEM_SALES_VALUE_BELOW_PROFIT_MARGIN = '2.7.25',
  MOVIMENTATION_SALE_ITEM_DELETE = '2.7.16',
  MOVIMENTATION_SALE_ITEM_EDIT = '2.7.15',
  MOVIMENTATION_SALE_ITEM_ADD = '2.7.14',
  MOVIMENTATION_SALE_MAKE_SALE_ABOVE_CREDIT_LIMIT = '2.7.12',
  MOVIMENTATION_SALE_GIVE_DISCOUNT_OVER_LIMIT = '2.7.11',
  MOVIMENTATION_SALE_GENERATE_FINANCIAL = '2.7.10',
  MOVIMENTATION_SALE_NEGOTIATE_FINANCIAL = '2.7.9',
  MOVIMENTATION_SALE_CANCEL = '2.7.8',
  MOVIMENTATION_SALE_AUTHORIZE = '2.7.7',
  MOVIMENTATION_SALE_EDIT_SALE_PRINTED = '2.7.6',
  MOVIMENTATION_SALE_PRINT = '2.7.5',
  MOVIMENTATION_SALE_DELETE = '2.7.4',
  MOVIMENTATION_SALE_DELETE_CANCELED = '2.7.4.1',
  MOVIMENTATION_SALE_EDIT = '2.7.3',
  MOVIMENTATION_SALE_ADD = '2.7.2',
  MOVIMENTATION_SALE_VIEW = '2.7.1',
  MOVIMENTATION_SALE_DIRECT_SALE = '2.7',
}
